import { Condition } from '../../../@types/Condition';
import { RadioItem } from '../../../Components/Input/InputRadioGroup';
import { translateCondition } from '../../../Utils/constants';

const Usps = {
  [Condition.VeryGood]: [
    'Inga repor eller skador',
    'Servad vid varje tillfälle med stämplar i serviceboken',
    'Däck med väldigt bra mönsterdjup (5-8 mm)',
  ],
  [Condition.Good]: [
    'Några mindre repor och/eller skador',
    'Servad vid varje tillfälle med stämplar i serviceboken',
    'Däck som inte behöver bytas (mönsterdjup om 3-5 mm)',
  ],
  [Condition.Ok]: [
    'Finns en del repor och skador',
    'Inte servad vid varje tillfälle',
    'Däck som behöver bytas (mönsterdjup under 3 mm)',
  ],
};

const createDescription = (usp: string[]) => `
  <div class="waykevaluation-box">
    <div class="waykevaluation-content waykevaluation-content--inherit-size">
      <ul class="waykevaluation-content__ul">
        ${usp.map((u) => ` <li class="waykevaluation-content__li">${u}</li>`).join('')}
      </ul>
    </div>
  </div>
`;

const RadioElements: RadioItem[] = [
  {
    id: `radio-${Condition.VeryGood}`,
    value: Condition.VeryGood,
    title: translateCondition[Condition.VeryGood],
    description: createDescription(Usps[Condition.VeryGood]),
  },
  {
    id: `radio-${Condition.Good}`,
    value: Condition.Good,
    title: translateCondition[Condition.Good],
    description: createDescription(Usps[Condition.Good]),
  },
  {
    id: `radio-${Condition.Ok}`,
    value: Condition.Ok,
    title: translateCondition[Condition.Ok],
    description: createDescription(Usps[Condition.Ok]),
  },
];

export default RadioElements;
